// firebase.js
import { initializeApp } from "firebase/app";
import { getMessaging } from "firebase/messaging";

// Firebase configuration (replace with your actual Firebase config)
const firebaseConfig = {
  apiKey: "AIzaSyCXWOLBP_rCWiJhK2G5s3kxYnfRR7cGZM8", // Your Firebase API Key
  authDomain: "prime-shark-57b43.firebaseapp.com", // Your Firebase Auth Domain
  projectId: "prime-shark-57b43", // Your Firebase Project ID
  storageBucket: "prime-shark-57b43.appspot.com", // Your Firebase Storage Bucket
  messagingSenderId: "101361721221", // Your Firebase Messaging Sender ID
  appId: "1:101361721221:web:beb5a0a12267d6da7d6eec", // Your Firebase App ID
  measurementId: "G-FS35WRZLCT", // Your Firebase Measurement ID
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
console.log("app initialized");

// Get the messaging instance
export const messaging = getMessaging(app);
